import './App.css';
import React, { useEffect, useRef, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useParams } from 'react-router-dom';
import { checkLogin } from './store/auth-actions';
import { useDispatch, useSelector } from 'react-redux'
import LayoutDashboard from './components/Pages/Dashboard/LayoutDashboard';
import Layout from './components/Layout';
import * as PathRouter from './models/PathRoute'
import FAQ from './components/Pages/Dashboard/HeaderDashboard/FAQ'
// import Project from './components/Pages/Projects/Project';
import Dashboard from './components/Pages/Dashboard/Home/Dashboard';
import Lessons from './components/Pages/Dashboard/Lessons/Lessons';
import Projects from './components/Pages/Projects/Projects';
import Project from './components/Pages/Project/Project';
import Friends from './components/Pages/Dashboard/Friends/Friends';
import Reports from './components/Pages/Dashboard/Reports/Reports';
import Lesson from './components/Pages/Lesson/Lesson';
import Welcome from './components/Pages/StudyGroups/Welcome';
import goToComputer from './assests/go-to-computer.png';
import CurriculumPage from './components/Pages/StudyGroups/CurriculumPage';
import LoginErrorPage from "./components/lms-shared/errors/LoginErrorPage";
import IdeRunnerWarrper from './components/lms-shared/IdeRunnerWarrper/IdeRunnerWarrper';
import ProjectViewer from './components/Pages/ProjectViewer/ProjectViewer';
import CurriculumPageWarrper from './components/Pages/StudyGroups/CurriculumPageWarrper';
import CurriculumPageDirectLink from './components/Pages/StudyGroups/CurriculumPageDirectLink';
import { useSignalR } from './components/lms-shared/hooks/useSignalR';
import { getGeneral } from './store/general-actions';
import MyProject from './components/Pages/Projects/MyProject';
import useAnalytics from './components/lms-shared/hooks/useAnalytics';
import ProjectViewerPublic from './components/Pages/ProjectViewer/ProjectViewerPublic';



function App() {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const { externalId, lastName, firstName } = useSelector((state) => state.auth.user);
  const { backgroundVideo, backgroundImg } = useSelector((state) => state.application);
  const uiData = useSelector((state) => state.general.uiData);
  const applictionName = useParams();
  const { lessonId } = useParams();
  const [dataAr, setDataAr] = useState();
  const [dataHe, setDataHe] = useState();
  const [dataEn, setDataEn] = useState();
  const [setMessage] = useState(null)

  useEffect(() => {
    dispatch(getGeneral())
  }, [])

  useEffect(() => {
    if (externalId) {
      if (uiData.apm && !uiData.apm.unable) {
        window.elasticApm.setUserContext({ id: externalId, username: `${firstName} ${lastName}` })
      }
    }
  }, [externalId])

  useSignalR(setMessage);
  useAnalytics()

  return (

    <Routes >
      <Route path=":applictionName" >
        <Route path="projectRunner/:postId" element={<IdeRunnerWarrper></IdeRunnerWarrper>}></Route>
        <Route path="projectCodePublic/:postId" element={<ProjectViewerPublic />}></Route>
        <Route path="error" element={<LoginErrorPage />} ></Route>
        {/* <Route path="trytofixerror" element={<LoginErrorPage tryAgain={true} />} ></Route> */}
        <Route element={<Layout></Layout>}>
          {isAuthenticated ? <>
            <Route index element={<Welcome></Welcome>} />
            <Route path='connect/:courseId/:srstudyGroupId' element={<CurriculumPageWarrper></CurriculumPageWarrper>}></Route>
            <Route path='directConnect/:courseId/:srstudyGroupId' element={<CurriculumPageDirectLink></CurriculumPageDirectLink>}></Route>
            <Route path="projectCode/:postId" element={<ProjectViewer />}></Route>
            <Route path=':studyGroupId'>
              <Route index element={<Navigate to={PathRouter.Dashboard} replace />} />
              <Route path='project/:projectId' element={<Project enableSave={true}></Project>}>
              </Route>
              <Route path='lesson/:lessonId/proj' element={<MyProject />} />
              <Route path='lesson/:lessonId' element={<Lesson backUrl={`studyGroupId/${PathRouter.DASHBOARD}`} />}>
                <Route index element={<Navigate to={PathRouter.Learning} replace />} />
              </Route>
              <Route path="postproject/:postId" element={<ProjectViewer></ProjectViewer>}></Route>
              <Route path="" element={<LayoutDashboard></LayoutDashboard>}>
                <Route path={PathRouter.Dashboard} element={< Dashboard />}></Route>
                <Route path={PathRouter.FAQ} element={<FAQ />}></Route>
                <Route path={PathRouter.ASSESSMENTS} element={<Lessons />}></Route>
                <Route path={PathRouter.PROJECTS} element={<Projects />}></Route>
                <Route path={PathRouter.FRIENDS} element={<Friends />}></Route>
                <Route path={PathRouter.REPORTS} element={<Reports />}></Route>
              </Route>
            </Route>
          </> : <>
            <Route index element={<div></div>} />
            <Route path='*' element={<div></div>}></Route>
          </>}
        </Route >
      </Route>
    </Routes>
  );
}

export default App;